import React from 'react';
import clsx from 'classnames';
import './index.css';

const Core = () => {
  const coreType = [
    {
      name: '自主开发',
      desc: '检测设备软、硬件均为自主开发，具有100%所有权，可满足不同客户的不同需求。',
    },
    {
      name: '万物互联',
      desc: '具备前沿物联网的开发技术，打造检测行业的“万物互联”新模式。',
    },
    {
      name: '管理软件',
      desc: '具有各种实验室管理软件和APP（包括安卓和IOS）的开发技术。',
    },
    {
      name: '研发制造',
      desc: '各种非标设备的研发和制造技术。',
    },
  ];

  return (
    <div className={clsx('blurb-content__core')}>
      <div className={clsx('blurb-content__core-title')}>核心技术</div>
      <div className={clsx('blurb-content__core-type')}>
        {coreType?.map((v, index) => {
          return (
            <div className={clsx('blurb-content__core-type-item')} key={index}>
              <div className={clsx('blurb-content__core-type-item-name')}>
                {v.name}
              </div>
              <div className={clsx('blurb-content__core-type-item-desc')}>
                {v.desc}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Core;
